const MyProduct = ({ item, handleClick }) => {
  const { name, serialnumber, url } = item;
  return (
    <div className="card has-text-centered">
        <div className="card-content">
            <figure className="image is-128x128 is-inline-block">
                <img src={url} alt="Image" />
            </figure>
            <p>{name.substring(0, 25)+"..."}</p>
            <p>Serial: {serialnumber}</p>
            <button className="button is-small is-link mt-1" onClick={() => handleClick(item)}>Add to Ticket</button>
        </div>
    </div>
  );
};

export default MyProduct;